module.exports = __webpack_public_path__ + "static/media/monster2.38f3a17f.png";